import React from "react";

import "./css/StepProgress.css";

const StepProgress = ({ steps, active, labels = null }) => {
  const activeItem = active || 0;

  return (
    <div className="progressbar-wrapper">
      <ul className="progressbar">
        {steps.map((step, i) => {
          return (
            <li key={i} className={i <= activeItem ? "active" : ""}>
              {labels && labels[i] ? labels[i] : step}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default StepProgress;
